import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { navigationMobile } from './Reducers/NavigationMobile.reducer';
import { facetedSearch } from "./Reducers/FacetedSearch.reducer";
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from "./Reducers/Checkout.reducer";
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { notification } from './Reducers/Notification.reducer';
import { cartbulkinsert } from './Reducers/CartBulkinsert.reducer';
import { pricelist } from './Reducers/Pricelist.reducer';
import { nshift } from './Reducers/NShift.reducer';

const app = combineReducers({
    cart,
    checkout,
    quickSearch,
    navigation,
    navigationMobile,
    myPage,
    facetedSearch,
    lightboxImages,
    notification,
    cartbulkinsert,
    pricelist,
    nshift
});

export default app;